"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactMethod = void 0;
var ContactMethod;
(function (ContactMethod) {
    ContactMethod["Call"] = "Call";
    ContactMethod["Email"] = "Email";
    ContactMethod["SMS"] = "SMS";
    ContactMethod["Letter"] = "Letter";
    ContactMethod["DoNotContact"] = "Do Not Contact";
})(ContactMethod = exports.ContactMethod || (exports.ContactMethod = {}));
//# sourceMappingURL=ContactMethod.js.map